import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import moment from 'moment';
import { SearchTicketByID } from '../../utils/apiUtils';
import './TicketModal.scss';

const TicketModal = ({ ticketId, onClose }) => {
  const [ticketDetails, setTicketDetails] = useState(null);

const formatDate = (date) => {
return date ? moment(date).format('DD-MM-YYYY HH:mm') : '';
};

  useEffect(() => {
    const fetchTicketDetails = async () => {
      try {
        const details = await SearchTicketByID(ticketId);
        setTicketDetails(details.data);
      } catch (error) {
        console.error('Error fetching ticket details:', error);
      }
    };

    fetchTicketDetails();
  }, [ticketId]);

  const handleClose = () => {
    setTicketDetails(null);
    onClose(); // Call the onClose function passed as prop
  };

  return (
    <Dialog open={Boolean(ticketDetails)} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ticket Details</DialogTitle>
      <DialogContent>
        {ticketDetails ? (
          <>
            <Typography variant="body1">Ticket ID: {ticketDetails.ticket_id}</Typography>
            <Typography variant="body1">Ticket Name: {ticketDetails.ticket_name}</Typography>
            <Typography variant="body1">Ticket Owner Name: {ticketDetails.ticket_owner_name}</Typography>
            <Typography variant="body1">Feedback Received: {formatDate(ticketDetails.feedback_received)}</Typography>
            <Typography variant="body1">Feedback Sent: {formatDate(ticketDetails.feedback_sent)}</Typography>
            <Typography variant="body1">Ticket Claimed: {formatDate(ticketDetails.ticket_claimed)}</Typography>
            <Typography variant="body1">Ticket Closed: {formatDate(ticketDetails.ticket_closed)}</Typography>
            <Typography variant="body1">Ticket Created: {formatDate(ticketDetails.ticket_created)}</Typography>
            <Typography variant="body1">Ticket Score: {ticketDetails.ticket_score}</Typography>
            <Typography variant="body1">Ticket Feedback: {ticketDetails.ticket_feedback}</Typography>

          </>
        ) : (
          <DialogContentText>Loading ticket details...</DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TicketModal;
